// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_main_webapp_i18n_en_en_js":"1c48e055","src_main_webapp_i18n_es_es_js":"9f051eb4","account":"11cfd3b8","vendors-node_modules_recharts_es6_cartesian_CartesianGrid_js-node_modules_recharts_es6_chart_-d442dc":"7236c453","administration":"89d31e3d"}[chunkId] + ".chunk.js";
};